import { ViewModel } from "../../../CoreTypes";
import { LocalizedString } from "../../../Localization/ILocalizer";

import { IValidationContext, IValueValidator, ValidationResult } from "./IValueValidator";

export abstract class ValueValidatorBase implements IValueValidator {
    public abstract validate(
        context: IValidationContext,
        nodeViewModel: ViewModel
    ): ValidationResult | Promise<ValidationResult>;

    protected getMessage(context: IValidationContext, message: undefined | LocalizedString): undefined | string {
        if (message == undefined) {
            return undefined;
        }
        if (typeof message === "string") {
            return message;
        }
        return message(context.localizer);
    }

    public asDebugString(): string {
        return "ValueValidatorBase()";
    }
}
